import { tv } from 'tailwind-variants';

export const loaderTheme = tv({
  slots: {
    root: 'm-auto w-max',
    spinner: 'animate-spin rounded-full border-2 border-primary/30 border-t-primary',
  },
  variants: {
    size: {
      xxs: { spinner: 'size-3' },
      xs: { spinner: 'size-4' },
      sm: { spinner: 'size-6' },
      md: { spinner: 'size-8 border-3' },
      lg: { spinner: 'size-12 border-4' },
    },
  },
  defaultVariants: {
    size: 'sm',
  },
});

export type LoaderVariants = typeof loaderTheme;
